import { sidebarLinks } from 'utility';

sidebarLinks({
  sectionClass: '.page-links',
  currentLinkClass: 'page-links__link--current',
  blockLinksClass: '.page-links__content .block-anchor',
  linksParentClass: '.page-links__nav',
  linksClass: '.page-links__links',
  linksActiveClass: '.page-links__links--active',
  linksFixedClass: '.page-links__links--fixed',
  linkClass: '.page-links__link'
});
